import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

/* pages */
const Descargas = () => import('./pages/descargas/Index' /* webpackChunkName: 'descargas' */);
const Estadisticas = () => import('./pages/estadisticas/Index' /* webpackChunkName: 'estadisticas' */);
const Nomina = () => import('./pages/nomina/Index' /* webpackChunkName: 'nomina' */);
const Pilotaje = () => import('./pages/pilotaje/Index' /* webpackChunkName: 'pilotaje' */);
const PuntajesPaes = () => import('./pages/resultados/PuntajesPaes' /* webpackChunkName: 'puntajesPaes' */);
const Registro = () => import('./pages/registro/Index' /* webpackChunkName: 'registro' */);
const ResultadoSeleccion = () => import('./pages/resultados/seleccion/Index' /* webpackChunkName: 'resultadoSeleccion' */);
const ResultadosPilotaje = () => import('./pages/resultados/Piloto' /* webpackChunkName: 'resultadosPilotaje' */);
const CaracterizacionLocal = () => import('./pages/local/Index' /* webpackChunkName: 'caracterizacionLocal' */);

const routes = [
  {
    path: '/',
    name: 'registro',
    component: Registro
  },
  {
    path: '/nomina',
    name: 'nomina',
    component: Nomina
  },
  {
    path: '/pilotaje',
    name: 'pilotaje',
    component: Pilotaje
  },
  {
    path: '/puntajes-paes',
    name: 'puntajesPaes',
    component: PuntajesPaes
  },
  {
    path: '/resultados-pilotaje',
    name: 'resultadosPilotaje',
    component: ResultadosPilotaje
  },
  {
    path: '/resultado-seleccion',
    name: 'resultadoSeleccion',
    component: ResultadoSeleccion
  },
  {
    path: '/descargas',
    name: 'descargas',
    component: Descargas
  },
  {
    path: '/estadistica-resultados-puntajes',
    name: 'estadisticas',
    component: Estadisticas
  },
  {
    path: '/caracterizacion-local',
    name: 'caracterizacionLocal',
    component: CaracterizacionLocal
  },

];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;

